import { updatePlayerData } from "@/api/player/api"
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { sendHelpForm } from "./api"

export const useSendHelpForm = () => {
  return useMutation({
    mutationKey: ["sendHelpForm"],
    mutationFn: ({ email, message }: { email: string; message }) => sendHelpForm({ email, message }),
  })
}
